export default __webpack_public_path__ + "static/media/logout.5cd89973.svg";